<template>
  <div :class="['panel-div']">
    <!-- <div class="title">
      <Breadcrumb v-if="noHome" separator=">">
        <BreadcrumbItem :to="homeLink">{{ home }}</BreadcrumbItem>
        <BreadcrumbItem :to="link">{{ title }}</BreadcrumbItem>
        <BreadcrumbItem v-if="subtitle" :to="sublink">{{
          subtitle
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div> -->
    <!-- <Breadcrumb v-else separator=">">
				<BreadcrumbItem to="/index">Home</BreadcrumbItem>
				<BreadcrumbItem :to = "link">{{title}}</BreadcrumbItem>
				<BreadcrumbItem v-if="subtitle" :to = "sublink">{{subtitle}}</BreadcrumbItem>
			</Breadcrumb> -->
    <div class="body">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "CsPanel",
  props: ["title", "subtitle", "link", "sublink", "noHome", "homeLink", "home"],
  // 'icon',
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/panel/CsPanel.vue